import { NgModule } from '@angular/core';
import { CardVisualizationModule } from '@egovsolutions/angular-card-visualization';
import { EcheckHelpModule } from '@egovsolutions/angular-echeck-help';
import { MaterialModule } from '@material/material.module';
import { SharedModule } from '@shared/shared.module';
import { ManagePaymentMethodsComponent } from './components/dialogs/manage-payment-methods/manage-payment-methods.component';
import { NewPaymentMethodComponent } from './components/dialogs/new-payment-method/new-payment-method.component';
import { SelectPaymentMethodDialogComponent } from './components/dialogs/select-payment-method-dialog/select-payment-method-dialog.component';
import { NewPaymentMethodFormComponent } from './components/new-payment-method-form/new-payment-method-form.component';
import { PaymentMethodListItemCardIconComponent } from './components/payment-method-list-item-card-icon/payment-method-list-item-card-icon.component';
import { PaymentMethodListItemEcheckIconComponent } from './components/payment-method-list-item-echeck-icon/payment-method-list-item-echeck-icon.component';
import { PaymentMethodListItemComponent } from './components/payment-method-list-item/payment-method-list-item.component';
import { PaymentMethodSelectionControlComponent } from './components/payment-method-selection-control/payment-method-selection-control.component';
import { PaymentMethodSelectionListComponent } from './components/payment-method-selection-list/payment-method-selection-list.component';
import { PaymentService } from './services/payment.service';


@NgModule({
    imports:
    [
        SharedModule,
        MaterialModule,
        CardVisualizationModule,
        EcheckHelpModule,
    ],
    declarations:
    [
        NewPaymentMethodFormComponent,
        NewPaymentMethodComponent,
        PaymentMethodSelectionControlComponent,
        SelectPaymentMethodDialogComponent,
        PaymentMethodListItemComponent,
        PaymentMethodListItemCardIconComponent,
        PaymentMethodListItemEcheckIconComponent,
        ManagePaymentMethodsComponent,
        PaymentMethodSelectionListComponent,
    ],
    exports:
    [
        NewPaymentMethodFormComponent,
        PaymentMethodSelectionControlComponent,
        SelectPaymentMethodDialogComponent,
    ],
    providers:
    [
        PaymentService,
    ],
})
export class PaymentModule {}
